import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { renderTrustedMarkdown } from '~/functions/markdown'


export default /*#__PURE__*/_defineComponent({
  __name: 'SolutionEditorIntro',
  setup(__props) {

const showIxDefinesSolution = ref(false)

return { __sfc: true,showIxDefinesSolution, renderTrustedMarkdown }
}

})